import { useCallback, useState } from "react";

const useMenu = () => {

    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

    const handleShow = useCallback((event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    }, []);
    const handleClose = useCallback(() => {
        setAnchorEl(null);
    }, []);

    return {
        open: Boolean(anchorEl),
        anchorEl,
        handleShow,
        handleClose
    };
};

export default useMenu;